import { Button, Container, Flex, Heading } from '@chakra-ui/react'
import { useGetCurrentUser } from 'brokertslib/src/hooks/useUser'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { Section } from '../../components/Section'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { ChangePasswordForm } from '../../containers/users/ChangePasswordForm'
import { ArrowLeft } from '../../icons'

export const ProfileChangePasswordPage = () => {
  const navigate = useNavigate()
  const { data: userData } = useGetCurrentUser()

  // LDAP user cannot change password
  useEffect(() => {
    if (!userData?.data.hasPassword)
      navigate('/profile')
  }, [navigate, userData])

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Změna hesla</Heading>
              </Flex>
            }
            rightElements={
              <Button
                colorScheme="white"
                variant="ghost"
                onClick={() => navigate('/profile')}
              >
                <ArrowLeft color="secondary.500" />
                Zpět na profil
              </Button>
            }
          />
          <ChangePasswordForm></ChangePasswordForm>
        </PageContent>
      </Container>
    </Section>
  )
}
